const generateFaberHostName = () => {
  let hostname

  switch (process.env.NODE_ENV) {
    // if built to be deployed, it will get the api server based on where this repo is
    case 'production':
      if (process.env.REACT_APP_DEPLOY_ENV === 'staging') {
        hostname = process.env.REACT_APP_FABER_SIM_STAGING
      } else {
        hostname = process.env.REACT_APP_FABER_SIM_PROD
      }
      break

    // if in development mode, we can conditionally switch backends to test
    case 'development':
      // hostname = 'http://localhost:3080'
      hostname = process.env.REACT_APP_FABER_SIM_STAGING
      break

    default:
      break
  }

  return hostname
}

export default generateFaberHostName
